
import WizardBase from "../wizard/WizardBase";
import SelectCourse from "../wizard/steps/SelectCourse";
import CreateAcount from "../wizard/steps/CreateAcount";
import PaymentMethod from "../wizard/steps/PaymentMethod";
import PaymentRegistration from "../wizard/steps/PaymentRegistration";
import Confirmation from "../wizard/steps/Confirmation";

const routes = [
    {
        path: "/wizard",
        component: WizardBase,
        children: [
            {
                paths: {
                    es: 'seleccionar-curso',
                    ca: 'seleccionar-curs',
                },
                name: 'seleccionar-curso',
                component: SelectCourse
            },
            {
                paths: {
                    es: 'modalidad-de-pago',
                    ca: 'modalitat-de-pagament',
                },
                name: 'modalidad-de-pago',
                component: PaymentMethod
            },
            {
                paths: {
                    es: 'datos-personales',
                    ca: 'dades-personals',
                },
                name: 'crear-cuenta',
                component: CreateAcount
            },
            {
                paths: {
                    es: 'pago-para-la-preinscripcion',
                    ca: 'pagament-per-a-la-preinscripcio',
                },
                name: 'pago-para-la-preinscripcion',
                component: PaymentRegistration
            },
            {
                path: 'confirmacion-preinscripcion',
                name: 'confirmacion-preinscripcion',
                component: Confirmation,
                props: true
            },
            {
                path: ''
            },
            {
                path: '*',
            }
        ]
    }
];

for (let route of routes[0].children) {
    if (route.paths) {
        route.path = route.paths[window.appLocale];
        delete route.paths;
    }

    if (route.name !== 'seleccionar-curso' && route.name != 'confirmacion-preinscripcion') {
        route.beforeEnter = (to, from, next) => {
            if (!from.name) {
                return next({ name: 'seleccionar-curso' });
            }
            next();
        }
    }
}

export default routes;
